import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import InternalsList, { DispatchProps, OwnProps, StateProps } from './InternalsList';
import { StoreState } from 'src/store/reducers';
import { QueryParams } from 'src/types/grid';
import { getInternals, getInternalsCsv } from 'src/store/actions/internal-actions';
import { selectNameProviders } from '../../../../../../store/selectors/providers-selectors';
import { getProvidersSmall } from '../../../../../../store/actions/provider-actions';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        data: state.internals.data,
        inProgress: state.internals.inProgress,
        providers: selectNameProviders(state),
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (params: QueryParams) => dispatch(getInternals(params)),
        getDataCsv: (params: QueryParams) => dispatch(getInternalsCsv(params)),
        getProviders: (params: QueryParams) => dispatch(getProvidersSmall(params)),
    };
}

const InternalsListScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(InternalsList);

export default InternalsListScreen;
